
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/chapters/new-releases",
      function () {
        return require("private-next-pages/chapters/new-releases.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/chapters/new-releases"])
      });
    }
  